<template>
  <div class="qr-code-page">
    <div class="top-info">
      <span class="qr-title">QR codes</span>
      <tooltip-new dataTrack="Show Additional QR Codes view" :v2="true" iconAlign="middle" :isClickAway="true" hyper-link="https://intercom.help/hellopeter/en/articles/3771814-collect-reviews">&nbsp;&nbsp;About this feature</tooltip-new>
    </div>

    <!-- QR code  section -->
    <div class="outer-qr-container">
      <span v-if="is_loading || fetching_data"
            class="button is-white has-text-right preloader"
            :class="{'is-loading': (is_loading || fetching_data)}"></span>
      <div class="columns">

        <div class="qr-code-section-outer">
          <div class="qr-code-section">
            <section class="heading-text">
              <p>Preview</p>
            </section>
            <section class="section report-row">
              <p class="is-hidden-tablet is-size-6" v-text="businessCopyUrl"></p>
              <div class="level is-mobile rl">
                <div class="level-left">
                  <div class="level-item is-hidden-mobile" ref="qrcontainer">
                    <div id="qr-code-container">
                      <div class="qr-code-logo">
                        <img v-if="includeHPLogo" id="hpb-logo" src="/static/img/logo/logo_b2c-trimmed.svg" srcset=""/>
                      </div>
                      <qrcode-vue :value="businessCopyUrl" :size="size" level="H"></qrcode-vue>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section class="qr-size-section padding-top-15">
              <p v-if="isSizeSmall" class="qr-desc">
                This QR code is the perfect size to put on your company invoices and emails. Once a customer has
                finished their business with you, they’re able to quickly jump onto your review
                landing page and publish their experience.
              </p>
              <p v-else class="qr-desc">
                If you’re a brick and mortar store, the medium size is perfect to have at your PoS (Point-of-Sale).
              </p>
              <div class="qr-size-options">
                <p>Select your size</p>
                <div class="field">
                  <div class="control">
                    <label class="radio">
                      <input type="radio" name="question" v-model="size" value="130">
                      <span class="qr-desc">
                        Small, intended use:
                        <strong>invoices/email</strong>
                        <span class="f11">(130 &times; 130px) Approx: (35 &times; 35mm)</span>
                      </span>
                    </label>
                  </div>
                  <div class="control">
                    <label class="radio">
                      <input type="radio" name="question" v-model="size" value="200">
                      <span class="qr-desc">
                        Medium, intended use:
                        <strong>print/in-store</strong>
                        <span class="f11">(50 &times; 50mm)</span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="qr-brand-options margin-top-5">
                <p>Branding</p>
                <div class="field">
                  <div class="control">
                    <label class="radio">
                      <input type="radio" name="hpLogo" :value="true" v-model="includeHPLogo">
                      <span class="qr-desc">Include our Hellopeter logo</span>
                    </label>
                  </div>
                  <div class="control">
                    <label class="radio">
                      <input type="radio" name="hpLogo" :value="false" v-model="includeHPLogo">
                      <span class="qr-desc">Exclude our Hellopeter logo</span>
                    </label>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div class="qr-code-list-outer">
          <p class="qr-title">Your QR codes</p>

          <p class="qr-desc">
            QR codes allow your customers to scan the code, and immediately be taken to your review page. QR codes are
            used best in-store (point-of-sale), or on invoices and emails.
          </p>
          <p v-if="subscriptionName === 'Free'" class="qr-desc">
            On our Free plan, you only have one QR available, which means you won't be able to track where your
            reviews
            are coming from. With our Growth plan, you have up to 10 codes, which you can name and track easily.
          </p>
          <p v-if="isGrowth" class="qr-desc">
            Use our CSV template to upload your QR code descriptors. Because you’re on our
            Growth plan, you get 10 different QR codes to use. Name them by downloading our
            CSV template so you know which of your codes are bringing in the most reviews.
            <a :href="getTemplateUrl" data-track="Download Additional QR Code CSV template" download class="blue-link"><u>Download CSV
              template</u></a>
          </p>
          <p v-if="!isGrowth && subscriptionName !== 'Free'" class="qr-desc">
            Use our CSV template to upload your QR code descriptors. Because you’re on our Premium
            plan, you get 200 different QR codes to use. Name them by downloading our
            CSV template so you know how your branches or stores are performing relative to
            one another.
            <a :href="getTemplateUrl" data-track="Download Additional QR Code CSV template" download class="blue-link"><u>Download CSV
              template</u></a>
          </p>
          <!-- csv upload section start -->
          <div v-if="subscriptionName !== 'Free'" class="csv-upload is-flex">
            <vue-dropzone ref="uploadField" id="dropzone" :options="dropzoneOptions"
                          data-track="Upload CSV for Additional QR Codes" :useCustomSlot=true
                          @vdropzone-file-added="uploadCsv" @vdropzone-error="errorHandle">
              <img src="/static/img/upload-file-icon.svg"/>
              <p class="qr-desc">Drop your CSV file or <a class="blue-link">select a file</a></p>
            </vue-dropzone>
            <a href="" ref="errorFileDownLink" target="_blank" download class="is-hidden"></a>
          </div>
          <!-- csv upload section end -->
          <div class="qr-code-res-count is-flex">
            <p class="is-pulled-left column is-two-fifths">QR codes remaining ({{ qrCodeStats.pending - 1 }} /
              {{ qrCodeStats.limit }})</p>
            <p class="customer-head-text column is-two-fifths">
              <span v-if="recordsAdded" class="queue-sent">
              <i class="fa fa-check" aria-hidden="true"></i> {{ recordsAdded }} QR code{{ recordsAdded > 1 ? 's' : '' }} added
              </span>
              <span v-if="recordsFailed" class="queue-not-added"><i class="fa fa-times" aria-hidden="true"></i>&nbsp; {{ recordsFailed }} not added
                <span style="color:grey;">-</span>
                <a href="javascript:void(0);" @click="$refs.errorFileDownLink.click()" class="error-download-link blue-link">download error file</a>
              </span>
            </p>
            <p class="is-pulled-right column has-text-right">
              <a v-if="subscriptionName !== 'Free'" class="link" @click="downloadAll"
                 data-track="Download ALL Additional QR Codes">
                <img src="/static/img/blue-download-icon.svg" width="14" height="15" alt="download-qr-code"
                     class="download-icon download-all-icon">
                <span class="m-left-4 text-underline">Download all</span>
              </a>
            </p>
          </div>
          <div class="level">
            <table class="table is-size-7-touch is-marginless">
              <thead>
              <tr>
                <td class="is-narrow-mobile is-size-7-mobile is-size-7-desktop has-text-grey w95">
                  Date added
                  <a v-if="subscriptionName !== 'Free'" href="javascript:void(0);" class="sorting-icons"
                     @click.prevent="sortBy('created_at')">
                    <img v-if="sortKey === 'name' || (sortKey === 'created_at' && sortOrder === 'desc')"
                         src="/static/img/up-arrow-icon.svg" alt="up-arrow-icon" class="up-arrow-icon">
                    <img v-if="sortKey === 'name' || (sortKey === 'created_at' && sortOrder === 'asc')"
                         src="/static/img/down-arrow-icon.svg" alt="down-arrow-icon"
                         :class="{'desc-sort-active': sortKey === 'name'}" class="down-arrow-icon">
                    <img v-if="sortKey === 'created_at' && sortOrder === 'asc'"
                         src="/static/img/blue_arrow_up_selected.svg" alt="selected-up-arrow-icon"
                         class="selected-up-arrow-icon">
                    <img v-if="sortKey === 'created_at' && sortOrder === 'desc'"
                         src="/static/img/blue_arrow_down_selected.svg" alt="selected-down-arrow-icon"
                         class="selected-down-arrow-icon">
                  </a>
                </td>
                <td class="pad70-desktop is-size-7-mobile is-size-7-desktop has-text-grey">Branch name
                  <a v-if="subscriptionName !== 'Free'" href="javascript:void(0);" class="sorting-icons"
                     @click.prevent="sortBy('name')">
                    <img v-if="(sortKey === 'name' && sortOrder === 'desc') || (sortKey === 'created_at')"
                         src="/static/img/up-arrow-icon.svg" alt="up-arrow-icon" class="up-arrow-icon">
                    <img v-if="(sortKey === 'name' && sortOrder === 'asc') || (sortKey === 'created_at') "
                         src="/static/img/down-arrow-icon.svg" alt="down-arrow-icon"
                         :class="{'date-sort-active': sortKey === 'created_at'}" class="down-arrow-icon">
                    <img v-if="sortKey === 'name' && sortOrder === 'asc'" src="/static/img/blue_arrow_up_selected.svg"
                         alt="selected-up-arrow-icon" class="selected-up-arrow-icon">
                    <img v-if="sortKey === 'name' && sortOrder === 'desc'"
                         src="/static/img/blue_arrow_down_selected.svg" alt="selected-down-arrow-icon"
                         class="selected-down-arrow-icon">
                  </a>
                </td>
                <td class="is-narrow-mobile is-size-7-mobile is-size-7-desktop has-text-grey w105">Last downloaded</td>
                <td class="is-narrow-mobile pad35-desktop is-desktop is-size-7-desktop has-text-grey w25"></td>
              </tr>
              </thead>
              <tbody>
              <tr v-if="page < 2 && subscriptionName === 'Free'">
                <td>{{ this.bizCreatedAt ? formattedDate(bizCreatedAt) : '' }}</td>
                <td>{{ localBillingDetails.billing_details.registered_name }} QR code</td>
                <td>{{ bizDownloadedAt ? formattedDate(bizDownloadedAt) : '' }}</td>
                <td>
                  <a href="javascript:void(0);" @click.prevent.default="createPDF()"
                     data-track="Download individual QR code">
                    <img src="/static/img/download-icon.png" width="15" height="15" alt="download-qr-code"
                         class="download-icon">
                  </a>
                </td>
              </tr>
              <template v-else>
                <tr v-for="(branch,index) in branches" :key="index">
                  <td>{{ branch.created_at ? formattedDate(branch.created_at) : '' }}</td>
                  <td>{{ branch.name }} QR code</td>
                  <td>{{ branch.downloaded_at ? formattedDate(branch.downloaded_at) : '' }}</td>
                  <td>
                    <a href="javascript:void(0);" @click.prevent.default="createPDF(branch.id ? branch : '')"
                       data-track="Download individual QR code">
                      <img src="/static/img/download-icon.png" width="15" height="15" alt="download-qr-code"
                           class="download-icon">
                    </a>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>

          </div>

          <div v-if="subscriptionName === 'Free'" class="upgrade-section">
            <p>
              <img src="/static/img/black-lock.svg" width="15" height="15" alt="Free Subscription" class="lock-icon">
            </p>
            <p>
              <a class="blue-link" href="/billing/edit-plan/g1/monthly"><u>Upgrade</u></a> to gain instant access to additional QR codes
            </p>
          </div>
          <div class="level pagination-section">
            <paginator :dataSet="dataSet" :keyword_string="keyword_string" @changed="getBranches"
                       :isNewPaginationActive="true"></paginator>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
import QrcodeVue from 'qrcode.vue'
import vue2Dropzone from 'vue2-dropzone'
import JSPDF from 'jspdf'
import html2canvas from 'html2canvas'
import Misc from './../../mixins/misc.js'
import axios from 'axios'
import moment from 'moment'
import Paginator from '../../components/Paginator.vue'
import {TooltipNew} from '@/widgets'

export default {
  metaInfo: {
    title: 'Business Portal | Hellopeter - Share Review QR Codes'
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Marketing Collect Reviews'
    })
  },
  name: 'ReviewsShareQRCodes',
  components: {
    vueDropzone: vue2Dropzone,
    QrcodeVue,
    Paginator,
    TooltipNew
  },
  mixins: [Misc],
  data () {
    return {
      businessName: localStorage.getItem('org_name'),
      businessSlug: localStorage.getItem('org_slug'),
      dataSet: {},
      total_records: 0,
      keyword_string: undefined,
      consumerFrontendUrl: process.env.HP_APP_URL,
      portalQRCode: process.env.QR_CODE,
      portalUrl: process.env.APP_URL,
      embedCode: undefined,
      size: 200,
      includeHPLogo: true,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        maxFiles: 1,
        headers: {'My-Awesome-Header': 'header value'},
        autoProcessQueue: false,
        addRemoveLinks: true,
        uploadMultiple: true,
        acceptedFiles: 'application/csv, text/csv'
      },
      uploading: false,
      recordsAdded: '',
      recordsFailed: '',
      branches: [],
      branchSlug: '',
      is_loading: false,
      fetching_data: false,
      qrCodeStats: [],
      bizDownloadedAt: '',
      bizCreatedAt: '',
      page: 1,
      faultyRecords: [],
      sortKey: 'created_at',
      sortOrder: 'desc',
      getTemplateUrl: `/static/assets/qr-template.csv`
    }
  },
  computed: {
    /**
     * checking current QR code as small
     *
     * @returns {boolean}
     **/
    isSizeSmall () {
      return this.size === '130'
    },
    getDefaultBizObj () {
      return [
        {
          'created_at': this.bizCreatedAt,
          'name': `${this.localBillingDetails.billing_details.registered_name}`,
          'downloaded_at': this.bizDownloadedAt,
          'id': ''
        }
      ]
    },
    businessCopyUrl () {
      let writeReviewUrl = `${this.consumerFrontendUrl}/write-a-review/${this.businessSlug}?source=${this.portalQRCode}&r=true`
      if (!this.branchSlug) {
        return `https://wa.me/27212066516?text=${encodeURIComponent('To start writing a review about ')}${encodeURIComponent(this.businessName)}${encodeURIComponent(' TAP THE SEND ARROW')}`
      } else {
        return writeReviewUrl + `&branch=${this.branchSlug}`
      }
    },
    /**
     * Return subscription name
     * @returns {string}
     *
     **/
    subscriptionName () {
      return this.localBillingDetails.subscription.name
    },
    isGrowth () {
      const liteCategory = ['Lite', 'Lite (Monthly)', 'G1 Annual', 'G2 Annual', 'G3 Annual', 'G4 Annual', 'G1 Monthly', 'G2 Monthly', 'G3 Monthly', 'G4 Monthly', 'G1', 'G2', 'G3', 'G4']
      return liteCategory.indexOf(this.localBillingDetails.subscription.name) !== -1
    }
  },
  methods: {
    createEmbedIframe () {
      this.embedCode = `<iframe frameborder="0" width="213" height="280" src="${this.portalUrl}/widgets/review-qrcodes/${this.businessSlug}"></iframe>`
    },
    /**
     * Generate pdf file
     *
     * @returns {void}
     * @param {Object} branch object used for downloading pdf of given branch
     **/
    createPDF (branch = null) {
      this.branchSlug = branch ? branch.slug : ''
      let qrCodeName = ''
      if (this.branchSlug) {
        this.downloadCSV(branch.id)
        qrCodeName = branch.name
      } else {
        this.downloadCSV(0)
        qrCodeName = this.getDefaultBizObj[0].name
      }
      setTimeout(() => {
        const doc = new JSPDF()
        const defaultHeight = document.querySelector('#qr-code-container').style.height
        const container = document.querySelector('#qr-code-container')
        const logoImg = container.querySelector('#hpb-logo')

        container.style.height = 750 + 'px'
        logoImg.classList.add('hpb-logo--print')
        html2canvas(this.$refs.qrcontainer).then((canvas) => {
          const img = canvas.toDataURL('image/png', 0.8)
          doc.addImage(img, 'PNG', 20, 20)
          doc.save(`${qrCodeName} QRcode.pdf`)
        })
        container.style.height = defaultHeight
        logoImg.classList.remove('hpb-logo--print')
      }, 100)
    },
    copyEmbedCode () {
      this.createEmbedIframe()
      this.$copyText(this.embedCode)
        .then(() => {
          flash(`Successfully copied to your clipboard`, 'is-success')
          dataLayer.push({
            'userMessage': {
              'messageType': 'success',
              'messageName': 'Successfully copied business URL to clipboard on Collect Reviews View',
              'displayedMessage': `Successfully copied to your clipboard`
            }
          })
        })
    },
    errorHandle (file) {
      this.$refs.uploadField.removeAllFiles()
    },
    /**
     * Upload csv file to generate QR code for this business
     *
     * @param {Object} file object for generating QR codes
     * @returns {void}
     */
    uploadCsv (file) {
      this.csvError = ''
      this.uploading = true
      let formData = new FormData()
      formData.append('file', file)
      axios.post(`/${this.businessSlug}/business-branch/upload-csv`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(({data}) => {
          this.$refs.uploadField.value = ''
          this.uploading = false
          this.recordsAdded = data.recordsAdded
          this.recordsFailed = data.recordsFailed
          this.getBranches(this.page)
          if (data.recordsFailed) {
            let csv = ['BRANCH_NAME,DESCRIPTION,ERROR']
            data.faultyRecords.forEach(row => {
              row = row.join(',')
              csv.push(row)
              this.faultyRecords.push(row)
            })
            csv = csv.join('\n')
            const fileName = file.name.split('.')
            fileName.pop()
            this.$refs.errorFileDownLink.download = `${fileName}_error.csv`
            this.$refs.errorFileDownLink.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
          }
          this.$refs.uploadField.removeAllFiles()
        })
        .catch(error => {
          this.$refs.uploadField.value = ''
          this.uploading = false
          this.displayErrMsg(error, 'Failed to upload CSV for review invite queue', `Failed to upload the file`)
        })
    },
    /**
     * Fetch all active branches for this business
     *
     * @returns {void}
     * @param {page} page number with default value 0
     */
    getBranches (page = 0) {
      if (!page) {
        let query = location.search.match(/page=(\d+)/)
        page = query ? query[1] : 1
      }
      this.is_loading = true
      this.fetching_data = true
      axios.get(`/${this.businessSlug}/business-branch/branches?page=${page}`)
        .then((response) => {
          this.refresh(response)
          this.bizDownloadedAt = response.data.bizDownloadedAt
          this.bizCreatedAt = response.data.bizCreatedAt
          this.branches = (parseInt(page) === 1) ? this.getDefaultBizObj.concat(response.data.data) : response.data.data
          this.branches = this.orderBy(this.branches, this.sortKey, this.sortOrder)
          this.qrCodeStats = response.data.qrCodeStats
          this.is_loading = false
          this.fetching_data = false
        })
        .catch(error => {
          this.uploading = false
          this.fetching_data = false
          this.displayErrMsg(error, 'Failed to fetch business branches records', `Failed to fetch business branches`)
        })
    },
    /**
     * Download csv file
     *
     * @returns {void}
     * @param {int} branchId used to download specific branch record
     *
     **/
    downloadCSV (branchId = 0) {
      axios.post(`/${this.businessSlug}/business-branch/download-csv`, {
        'branchId': branchId
      })
        .then((response) => {
          this.getBranches(this.dataSet.current_page)
        })
        .catch(error => {
          this.displayErrMsg(error, 'Failed to download CSV for business branch', `Failed to download the file`)
        })
    },
    /**
     * Download pdf for all records of this business
     *
     * @returns {void}
     *
     **/
    downloadAll () {
      if (this.branches.length > 0) {
        let that = this
        this.branches.forEach(function (branch) {
          if (branch.id) {
            that.createPDF(branch)
          } else {
            that.createPDF()
          }
        })
      }
    },
    /**
     * Filter to format created at
     *
     * @param {date} date datetime string
     * @returns {string}
     */
    formattedDate (date) {
      return moment(date).format('DD/MM/YY')
    },
    /**
     * Sort branch by using each column key
     *
     * @returns {void}
     * @param {key} key used for sorting branch table
     */
    sortBy (key) {
      if (this.sortKey === key) {
        this.sortOrder = (this.sortOrder === 'asc') ? 'desc' : 'asc'
      } else {
        this.sortOrder = 'asc'
      }
      this.sortKey = key
      this.branches = this.orderBy(this.branches, this.sortKey, this.sortOrder)
    }
  },
  created () {
    if (this.$route.query.hasOwnProperty('page')) {
      this.page = this.$route.query.page
    }
    this.getBranches(this.page)
  }
}
</script>

<style scoped>
#qr-code-container {
  background: #fff;
  padding: 29px 25px;
  padding-top: 25px;
}

#qr-code-container #hpb-logo {
  padding-bottom: 9px;
  display: flex;
  width: 142px;
  margin: 0 auto;
}

#qr-code-container #hpb-logo.hpb-logo--print {
  padding-bottom: 0;
  width: 170px;
  margin-left: 29px;
}

.report-row {
  background-color: #F5F5F5;
}

.section {
  padding: 1.5rem;
  margin: 0.75rem 0.75rem 0.75rem 0;
}

.generic {
  margin-top: 1.75rem;
}

.level.is-mobile .level-item:last-child {
  margin-right: 0;
}

.level:not(:last-child) {
  margin-bottom: 0;
}

@media screen and (max-width: 767px) {
  .section {
    padding: 1rem 0.75rem;
  }

  .buttons .button:not(:last-child) {
    margin-right: 0;
  }
}

.fl {
  position: absolute;
  display: block;
  left: 34%;
  top: 23%;
}

.rl {
  position: relative;
  justify-content: center;
}

.top-info {
  text-align: right;
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
  margin-left: -21px;
  margin-right: -21px;
  padding-right: 21px;
  position: relative;
  top: -23px;
  padding-bottom: 10px;
}

.top-info a {
  width: 111px;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  color: #58595b;
  flex: 1;
}

.top-info a img {
  margin-top: 5px;
}

.top-info a span {
  margin-top: -12px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 6px;
}

.abt_section {
  font-size: 12px;
}

.qr-title {
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.top-info > span {
  margin-left: 21px;
  flex: 6;
}

.qr-desc {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.f11 {
  font-size: 11px;
  margin-left: 0 !important;
}

.column p.qr-title {
  margin-bottom: 10px;
  margin-top: 2px;
}

.column p.qr-desc {
  margin-bottom: 15px;
}

/** css start for table **/
table.table {
  width: 100%;
}

.table > tbody > tr {
  background-color: #fff !important;
}

.table td, .table th {
  border-bottom: none !important;
  padding-left: 0 !important;
}

table tr {
  border-bottom: 1px solid #dbdbdb;
}

.upgrade-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
}

.upgrade-section p {
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: center;
  color: #58595b;
  margin-bottom: 8px;
}

.heading-text p {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.08;
  letter-spacing: normal;
  text-align: left;
  color: #4d4f5c;
}

.heading-text {
  padding: 7px 20px;
  background-color: #f7f8f8;
  margin-top: 0.5px;
  height: 31px;
  display: flex;
  align-items: center;
}

.section.report-row {
  margin: 0px !important;
}

.qr-code-section {
  padding-right: 26px;
  padding-bottom: 20px;
}

.qr-size-section {
  padding-top: 15px;
}

.qr-size-options p, .qr-brand-options p {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.83;
  letter-spacing: normal;
  text-align: left;
  color: rgba(88, 89, 91, 0.6);
  border-bottom: 0.5px solid #dbdbdb;
  padding-bottom: 5px;
  margin-bottom: 10px;
}

.qr-size-options .field .control, .qr-brand-options .field .control {
  margin: 14px auto;
}

.outer-qr-container {
  padding-bottom: 40px;
}

.qr-brand-options p {
  margin-top: 20px;
}

.control .radio span {
  margin-left: 8px;
}

.qr-code-res-count p {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.08;
  letter-spacing: normal;
  text-align: left;
  color: #4d4f5c;
  padding-left: 0;
}

.qr-code-res-count {
  margin-top: 25px;
  margin-bottom: 7px;
}

.qr-code-section-outer {
  width: 43%;
  border-right: 1px solid #DBDBDB;
}

.qr-code-list-outer {
  width: 54%;
  padding-left: 26px;
  position: relative;
}

.qr-code-res-count a {
  justify-content: space-evenly;
  /*margin-right: 8px;*/
}

.qr-code-res-count p:last-child {
  padding-left: 0;
  padding-right: 0;
}

.csv-upload {
  position: relative;
  margin-top: 7px;

}

.csv-upload .dropzone {
  min-height: 0px !important;
  border: none;
  background-color: rgba(243, 243, 243, 0.4);
  width: 100%;
  padding: 0 !important;
}

.csv-upload .dz-message {
  margin: 0px !important;
}

.csv-upload .dropzone-custom-title {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: center;
  color: #58595b;
}

.csv-upload .qr-desc {
  text-align: center;
}

.customer-head-text span.queue-sent {
  font-size: 11px !important;
  color: #17be86;
  line-height: 15px;
  font-weight: normal;
}

.customer-head-text span.queue-not-added {
  font-size: 11px !important;
  margin-left: 11.8px;
  margin-right: 5px;
  color: #d51f1f;
  line-height: 15px;
  font-weight: normal;
}

.customer-head-text a.error-download-link {
  font-size: 11px !important;
  margin-left: 4.5px !important;
  line-height: 15px;
  font-weight: normal;
}

.pagination-section {
  position: absolute;
  right: 0;
  bottom: -51px;
  padding-bottom: 12px;
}

.sorting-icons {
  display: inline-grid;
  cursor: pointer;
  height: 22px;
}

.sorting-icons .down-arrow-icon {
  position: relative;
  top: 10px;
}

.sorting-icons .date-sort-active, .sorting-icons .desc-sort-active {
  position: relative;
  top: -8px;
}

.selected-up-arrow-icon {
  margin-bottom: 2px;
  position: relative;
  bottom: 10px;
  left: 4px;
}

.selected-down-arrow-icon {
  position: relative;
  bottom: 2px;
  left: 4px;
}

.qr-code-page {
  margin-top: -4px;
  position: relative;
}

.download-all-icon {
  margin-top: -2px;
}

.w95 {
  width: 95px;
}

.w105 {
  width: 105px;
}

.w25 {
  width: 25px;
}
</style>



// WEBPACK FOOTER //
// src/pages/collect-reviews/QRCodes.vue